import { PricinigPlanSVG } from "../../../assets/common/AdminSvg";
import PricingPlanBody from "./PricingPlanBody";

const PricingPlanModal = ({
  modalPriceUpdate,
  setModalPriceUpdate,
  data,
}: any) => {
  return (
    <div className="flex flex-col items-center gap-6 px-8 pb-8 bg-white">
      {modalPriceUpdate || (
        <h3 className="text-2xl font-semibold text-color-primary">
          {data?.name}
        </h3>
      )}
      <div className="flex flex-col items-center">
        <span>{PricinigPlanSVG}</span>
        <div className="text-color-primary font-semibold text-sm flex items-center gap-[2px] mt-4">
          {data?.name !== "free" || (
            <>
              <span className="text-2xl">350</span>
              <span className="text-[8px]">SR/Month</span>
            </>
          )}
          <span className="text-2xl font-bold">
            {data?.subscriptionPlan?.name}
          </span>
        </div>
        {modalPriceUpdate && (
          <h3 className="text-2xl font-semibold text-color-primary">
            {data?.name}
          </h3>
        )}
      </div>
      <PricingPlanBody
        currentPlan={data}
        modalPriceUpdate={modalPriceUpdate}
        setModalPriceUpdate={setModalPriceUpdate}
      />
    </div>
  );
};

export default PricingPlanModal;
